import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Input from '../../../common/input';
import CurrencyInput from '../../../common/currencyInput';
import DatePicker from '../../../common/DatePickerRedux';
import AdminSaveButton from '../../shared/Buttons/AdminSaveButton';

const Loan = ({ handleSubmit, submitting, loanAmountOwed, loanDetailHistory, currency, dateFormat }) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={handleSubmit}>
          <fieldset disabled={submitting}>
            <div className="u-ph">
              <div className="layout">
                <div className="layout__item">
                  <div className="c-label-new">Amount Borrowed</div>
                  <CurrencyInput
                    className="c-input"
                    placeholder="Amount Borrowed"
                    name="loanAmountBorrowed"
                    currency={currency}
                  />
                </div>
                <div className="layout__item" display-if={loanAmountOwed}>
                  <div className="c-label-new">Amount Owed</div>
                  <CurrencyInput
                    className="c-input"
                    placeholder="Amount Owed"
                    name="loanAmountOwed"
                    currency={currency}
                    disabled
                  />
                </div>
                <div className="layout__item">
                  <div className="c-label-new">Repayment %</div>
                  <Input
                    className="c-input"
                    name="loanRepaymentPercentage"
                    type="text"
                    prefix="%"
                  />
                </div>
                <div className="layout__item">
                  <div className="c-label-new">Repayment Start Date</div>
                  <DatePicker
                    className="c-input u-1/1"
                    name="loanRepaymentStartDate"
                    addClearBtn
                    startDate={new Date()}
                    placeholder={dateFormat}
                    defaultValue={''}
                  />
                </div>
                <div className="u-text-right">
                  <AdminSaveButton content="Save" />
                </div>
                <div className="layout__item">
                  <div className="c-label c-label--light u-mb-">Logs</div>
                  <span className="c-label--light" display-if={isEmpty(loanDetailHistory)}>
                    No previous activity.
                  </span>
                  <ReactTable
                    display-if={!isEmpty(loanDetailHistory)}
                    columns={[
                      {
                        Header: 'Log Time (UTC)',
                        accessor: 'logTimeUtc',
                      },
                      {
                        Header: 'Start Date (UTC)',
                        accessor: 'loanRepaymentStartDate',
                      },
                      {
                        Header: 'Borrowed Amount',
                        accessor: 'loanAmountBorrowed',
                      },
                      {
                        Header: 'Owed Amount',
                        accessor: 'loanAmountOwed',
                      },
                      {
                        Header: 'Repayment %',
                        accessor: 'loanRepaymentPercentage',
                      },
                      {
                        Header: 'Status',
                        accessor: 'loanStatus',
                      },
                    ]}
                    data={loanDetailHistory}
                    showPagination={false}
                    minRows={0}
                    className="c-table-new c-table--small c-table--border c-no-hover"
                    defaultSorted={[
                      {
                        id: 'logTimeUtc',
                        desc: true,
                      },
                    ]}
                    style={{
                      maxHeight: '200px',
                      maxWidth: '600px',
                    }}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
);

Loan.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
  loanAmountOwed: PropTypes.number.isRequired,
  loanDetailHistory: PropTypes.instanceOf(Array).isRequired,
  dateFormat: PropTypes.string.isRequired,
};

export default Loan;
